(function () {
    const isDev = globDev;
    
    // --- Моки ---
    const mockUrlFormSubmit = "/ajaxurl/iformsubmit";
    let mockCnt = 0;
    
    $.mockjax ({
        url: mockUrlFormSubmit,
        response: function (settings) {
            let hasCaptcha = false;
            let respObj = {
                success: false
            };
            $.each (JSON.parse (settings.data), function (i, v) {
                if (v.name === "grecaptcha") {
                    hasCaptcha = true;
                    return false;
                }
            });
            if (hasCaptcha) {
                respObj.success = mockCnt > 0;
                if (mockCnt === 0) {
                    respObj.captchaInvalid = true;
                }
                mockCnt++;
            } else {
                respObj.success = true;
            }
            this.responseText = respObj;
        }
    });
    
    // --- Компонент формы ---

    $.fn.extend({
        iFormElementGetMessage: function (code, type = "text") {
            const messages = {
                text: {
                    empty: "Обязательное поле",
                    min: "Минимальная длина",
                    max: "Максимальная длина"
                },
                textarea: {
                    empty: "Обязательное поле",
                    min: "Минимальная длина",
                    max: "Максимальная длина"
                },
                email: {
                    empty: "Обязательное поле",
                    invalid: "Некорректная почта"
                },
                phone: {
                    empty: "Обязательное поле",
                    invalid: "Некорректный телефон"
                },
                date: {
                    empty: "Обязательное поле",
                    invalid: "Некорректная дата"
                },
                time: {
                    empty: "Обязательное поле",
                    invalid: "Некорректное время"
                },
                password: {
                    empty: "Обязательное поле",
                    min: "Минимальная длина",
                    max: "Максимальная длина",
                    space: "Пароль не может начинаться или заканчиваться пробелом"
                },
                code: {
                    empty: "Заполните это поле",
                    invalid: "Некорректный код"
                }
            };

            return (messages[type][code]) ? messages[type][code] : "Некорректное значение";
        },

        iFormElementShowError: function (text, type = "text", isError = false) {
            const $element = $(this);
            
            if ($element.hasClass('ui-input-bordered')) {
                $element.trigger('inputError', [{text: text}]);
                
            } else if ($element.hasClass('i-form-textarea')) {
                $element.trigger('ab.textarea.error', [{text: text}]);
                
            } else {
                const noticeClass = (isError) ? '_error' : '_notice';
    
                $element.parent().addClass(noticeClass);
    
                const tSel = $element.data("i-form-error-target");
    
                if (tSel) {
                    const $tIn = $element.closest(".js-i-form").find(tSel);
                    const $tOut = $(tSel);
        
                    if ($tIn.length > 0) {
                        $tIn.html(text).removeClass("_hidden");
                        return;
            
                    } else if ($tOut.length > 0) {
                        $tOut.html(text).removeClass("_hidden");
                        return;
                    }
                }
    
                switch (type) {
                    case "textarea":
                        $element.parent().append('<span class="i-textarea-response">' + text + '</span>');
                        break;
        
                    default:
                        $element.parent().append('<span class="w-input-text__response">' + text + '</span>');
                        break;
                }
            }
        },

        iFormElementCleanError: function (type = "text") {
            const $element = $(this);
            
            if ($element.hasClass('ui-input-bordered')) {
                $element.trigger('inputResolveErrors');
                
            } else if ($element.hasClass('i-form-textarea')) {
                $element.trigger('ab.textarea.resolve');
                
            } else {
                const tSel = $element.data("i-form-error-target");
    
                $element.parent().removeClass('_error _notice');
    
                if (tSel) {
                    const $tIn = $element.closest(".js-i-form").find(tSel);
                    const $tOut = $(tSel);
        
                    if ($tIn.length > 0) {
                        $tIn.html("").addClass("_hidden");
                        return;
            
                    } else if ($tOut.length > 0) {
                        $tOut.html("").addClass("_hidden");
                        return;
                    }
                }
    
                switch (type) {
                    case "textarea":
                        $element.parent().find('.i-textarea-response').remove();
                        break;
        
                    default:
                        $element.parent().find('.w-input-text__response').remove();
                        break;
                }
            }
        },

        iFormElementCheck: function () {
            const $element = $(this);
            const response = $element.iFormElementCheckVal();

            const isError = (!response.isValid && !(!response.isRequired && response.code === "empty"));

            $element.iFormElementCleanError(response.type);

            if (isError) {

                let text = $element.data("i-form-" + response.code + "-text") || $.fn.iFormElementGetMessage(response.code, response.type);

                if (response.code === "min" || response.code === "max") {
                    text += " - " + $element.data("i-form-" + response.code + "-len") + " симв.";
                }

                $element.iFormElementShowError(text, response.type, response.isError);
            }

            return !isError;
        },

        iFormElementCheckVal: function () {
            const $element = $(this);
            const type = $element.data("i-form-role") || "text";
            const val = $element.val();
            const isRequired = $element.is(":required");

            let isEmpty = true;
            let isInvalid = false;
            let isError = false;
            let isWarning = false;
            let code = "";

            if (val === "") {
                isInvalid = true;
                code = 'empty';

            } else {
                isEmpty = false;

                switch (type) {
                    case "phone":
                    case 'time':
                    case 'code':
                        if (!$element.inputmask("isComplete")) {
                            isInvalid = true;
                            code = 'invalid';
                        }
                        break;

                    case "email":
                        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                        if (!re.test(String($element.val()).toLowerCase().trim ())) {
                            isInvalid = true;
                            code = 'invalid';
                        }
                        break;
                        
                    case "password":
                        const passMinLen = $element.data("i-form-min-len") || 0;
                        const passMaxLen = $element.data("i-form-max-len") || 0;
    
                        if (val.charAt(0) === " " || val.charAt(val.length - 1) === " ") {
                            isInvalid = true;
                            code = 'space';
                        } else if (val.length < passMinLen) {
                            isInvalid = true;
                            code = 'min';
                        } else if (passMaxLen > 0 && val.length > passMaxLen) {
                            isInvalid = true;
                            code = 'max';
                        }
                        break;

                    case "text":
                    case "textarea":
                        const minLen = $element.data("i-form-min-len") || 0;
                        const maxLen = $element.data("i-form-max-len") || 0;

                        if (val.length < minLen) {
                            isInvalid = true;
                            code = 'min';
                        } else if (maxLen > 0 && val.length > maxLen) {
                            isInvalid = true;
                            code = 'max';
                        }
                        break;
                }
            }

            if (isRequired && isInvalid) {
                if (!isEmpty) {
                    isError = true;
                } else {
                    isWarning = true;
                }
            } else if (!isRequired && !isEmpty && isInvalid) {
                isWarning = true;
            }

            return {
                isRequired: isRequired,
                isValid: !isInvalid,
                isError: isError,
                isWarning: isWarning,
                type: type,
                code: code
            }
        },

        iFormElementInit: function () {
            let $element;
            
            if ($(this).hasClass('ui-input-bordered')) {
                $element = $(this);
                
                $element.on("input", function () {
                    if ($element.hasClass("ui-input-bordered_state-empty") || $element.hasClass("ui-input-bordered_state-error")) {
                        $element.iFormElementCheck();
                    }
                });
                
            } else if ($(this).hasClass('i-form-textarea')) {
                $element = $(this);
                
                $element.on("input", function () {
                    if (this.dataset.state === 'error') {
                        $element.iFormElementCheck();
                    }
                });
                
            } else {
                const $wrap = $(this);
                $element = $wrap.find("[data-i-form-role]");
                
                $element.on("input", function () {
                    if ($wrap.hasClass("_error") || $wrap.hasClass("_notice")) {
                        $element.iFormElementCheck();
                    }
                });
            }
    
            // если поле телефона, инициализируем его
    
            if ($element.data("i-form-role") === "phone") {
                $element.inputmask({
                    mask: "+7  (X99)  999-99-99",
                    definitions: {
                        'X': {
                            validator: "[49]"
                        }
                    },
                    placeholder: "0",
                    clearMaskOnLostFocus: true,
                    showMaskOnFocus: true,
                    showMaskOnHover: false,
                    oncleared: ()=> {
                        $element.addClass('_gray');
                        $element.val();
                    }
                });
        
                $element.on ("input", function () {
                    $element.removeClass('_gray');
                });
                
            } else if ($element.data("i-form-role") === "code") {
                $element.inputmask({
                    mask: $element.data("i-form-mask") || "9999",
                    placeholder: "____",
                    clearMaskOnLostFocus: true,
                    showMaskOnFocus: true,
                    showMaskOnHover: false
                });
            }
    
            $element.on("blur", function () {
                $element.iFormElementCheck();
            });
        },
    
        iFormFormInit: function () {
            const $form = $ (this);
            const $submit = $form.find (".js-i-form__submit");
            const ajaxUrl = $form.data ("i-form-ajax-url");
        
            // если есть кнопка, обрабатываем её клик и, если всё ок, триггерим сабмит формы
            // если нет, то ничего не делаем :)
        
            if ($submit.length > 0) {
                $submit.on ("click", function (e) {
                    e.preventDefault ();
    
                    $form.trigger('is:submit.click');
                    
                    let erLen = 0;
                    $form.find ("[data-i-form-role]").each (function () {
                        const isValid = $ (this).iFormElementCheck ();
                        if (!isValid) erLen++;
                    });
                    if (erLen === 0) {
                        $form.trigger('is:submit.started');
                        
                        $form.find ("input, textarea, button").each (function () {
                            const $_this = $ (this);
                            if (!$_this.is (":disabled")) {
                                $_this.attr ("disabled", true).attr ("data-disabled-on-submit", true);
                            }
                        });
                        
                        const formSubmit = function() {
                            if ($form.hasClass ("form-recaptcha") && $form.find("[name=\"g-recaptcha-response\"]").length === 0) {
                                if ($form.find ("input[name=\"grecaptcha\"]").length === 0) {
                                    $form.append ("<input type=\"hidden\" name=\"grecaptcha\">");
                                }
                                $form.on ("recaptcha:token", function (e, token) {
                                    $form.find('input[name="grecaptcha"]').val(token);
                                    $form.trigger("submit");
                                });
                                $form.iFormRecaptchaToken ();
                            } else {
                                $form.trigger ("submit");
                            }
                        }
                        if ($form.hasClass('form-recaptcha') && !ABGrecaptchaLoader.isInWindow()) {
                            ABGrecaptchaLoader.load(
                                {key: $form.attr('data-sitekey-v3')},
                                formSubmit
                            );
                        } else {
                            // если рекапча в форме не требуется (обычно если не переданы ключи), просто вызываем колбэк
                            formSubmit();
                        }
                        
                    } else {
                        const $first = $form.find ("._error, ._notice").first ();
                        if ($first.length > 0) {
                            if ($.fancybox && $.fancybox.getInstance ()) {
                                $first.find ("input, textarea").focus ();
                            } else {
                                globalFunctions.scrollTo ($first.offset ().top - 100, function () {
                                    $first.find ("input, textarea").focus ();
                                });
                            }
                        }
                    }
                });
            }

            // если есть урл для аякса, шлём запрос
            // если нет, то ничего не делаем - предполагаем, что событие сабмита будет обработано где-то вне
    
            if (ajaxUrl || isDev) {
                
                const dataFormat = $form[0].dataset.iFormFormat;
                    
                // data - передаём как бы сквозь это событие в события, им вызываемые
                // чуть костыльно, но нужно для триггера событий аналитики
                $form.on ("submit", function (e, data = {}) {
                    e.preventDefault ();
                    
                    if ($form.hasClass ("form-recaptcha")) {
                        $form.unbind ("recaptcha:token");
                    }
                    $form.find ("input, textarea, button").each (function () {
                        const $_this = $ (this);
                        if ($_this.is (":disabled")) {
                            $_this.attr ("disabled", false).attr ("data-disabled-on-submit", false);
                        }
                    });
                    const formData = $form.serializeArray ();
                    const ajaxData = (dataFormat === 'object') ? {} : [];
                    
                    $.each (formData, function (k, param) {
                        let paramVal = param.value;
                        paramVal = paramVal.trim ();
                        if (dataFormat === 'object') {
                            ajaxData[param.name] = encodeURIComponent (paramVal);
                            
                        } else {
                            ajaxData.push ({"name": param.name, "value": encodeURIComponent (paramVal)});
                        }
                    });
                    const params = {
                        method: 'POST',
                        url: (!isDev) ? ajaxUrl : mockUrlFormSubmit,
                        data: JSON.stringify (ajaxData),
                        dataType: 'json'
                    };
                    $form.find ("input, textarea, button").each (function () {
                        const $_this = $ (this);
                        if (!$_this.is (":disabled")) {
                            $_this.attr ("disabled", true).attr ("data-disabled-on-submit", true);
                        }
                    });
            
                    const promise = $.ajax (params);
                    promise
                        .done (function (response) {
                            if (response.success === true) {
                                $form.trigger ("is:success", [response, data]);
                            } else if (response.captchaInvalid) {
                                $form.trigger ("is:captchaFail", [response, data]);
                            } else {
                                $form.find ("[data-disabled-on-submit=\"true\"]").each (function () {
                                    $ (this).attr ("disabled", false).attr ("data-disabled-on-submit", false);
                                });
                                $form.trigger ("is:fail", [response, data]);
                            }
                        })
                        .fail (function (jqXHR, textStatus, errorThrown) {
                            $form.find ("[data-disabled-on-submit=\"true\"]").each (function () {
                                $ (this).attr ("disabled", false).attr ("data-disabled-on-submit", false);
                            });
                            $form.trigger ("is:fail");
                        });
                });
            }
    
            $form.on ("is:fail", function (e, response, data) {
                $form.find ("[data-recaptcha-render]").html ("");
            });
    
            $form.on ("is:captchaFail", function (e, response, data) {
                if ($submit.length > 0) {
                    $submit.remove ();
                }
                $form.iFormRecaptchaRender (data);
            });
    
            $form.on ("is:success", function (e, response, data) {
                $form.find ("[data-recaptcha-render]").html ("");
            });
        },
    
        iFormRecaptchaToken: function () {
            const $form = $ (this);
            const keyV3 = $form.data ("sitekey-v3");
            if ("undefined" != typeof(grecaptcha) && keyV3) {
                grecaptcha.ready (function () {
                    grecaptcha.execute (keyV3, {action: 'submit'}).then (function (token) {
                        $form.trigger ("recaptcha:token", [token]);
                    })
                });
            }
        },
    
        iFormRecaptchaRender: function (data = {}) {
            const $form = $ (this);
            const keyV2 = $form.data ("sitekey-v2");
            const $block = $form.find ("[data-recaptcha-render]");
            if ("undefined" != typeof(grecaptcha) && keyV2 && $block.length > 0) {
                $block.find('.recaptcha-wrap').remove();
                grecaptcha.render ($ ("<div class=\"recaptcha-wrap\"></div>").appendTo ($block)[0], {
                    "sitekey": keyV2,
                    "callback": function (token) {
                        if ($form.find("input[name=\"grecaptchaV2\"]").length === 0) {
                            $form.append("<input type=\"hidden\" name=\"grecaptchaV2\">");
                        }
                        $form.find("input[name=\"grecaptcha\"]").remove();
                        $form.find("input[name=\"grecaptchaV2\"]").val(token);
                        $form.trigger("submit", [data]);
                    },
                    "error-callback": function () {
                        $form.trigger ("is:fail", [{}, data]);
                    }
                });
            }
        }
    });


    // элементы формы

    $(function () {

        $(".js-i-form-element:not([data-no-init])").each(function () {
            $(this).iFormElementInit();
        });


        $(".js-i-form:not([data-no-init])").each(function () {
            $(this).iFormFormInit();
        });
    
        $ (document).on ('propertychange input', 'input[data-input-number]', function (e) {
            const $_this = $ (this);
            $_this.val ($_this.val ().replace (/[^0-9]/g, ''));
        });
    })
}());
